module.exports = __webpack_public_path__ + "img/avatar-placeholder.9e66e202.png";